
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { ScrollComponent } from "@/assets/ts/components/_ScrollComponent";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import { version } from "@/core/helpers/documentation";
import { asideMenuIcons } from "@/core/helpers/config";
import MainMenuConfig from "@/core/config/MainMenuConfig";
import store from "@/store";
import router from "@/router";

export default defineComponent({
  name: "kt-menu",
  components: {},
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const scrollElRef = ref<null | HTMLElement>(null);

    // let ModuleAcess = JSON.parse(
    //   '[{"ModuleId":"2","AccessLvl":1},{"ModuleId":"8","AccessLvl":1},{"ModuleId":"32","AccessLvl":1},{"ModuleId":"33","AccessLvl":1}]'
    // );

    let ModuleAcess = JSON.parse(store.getters.ModuleAcess);

    if (ModuleAcess == null) {
      router.push({ name: "sign-in" });
    }

    onMounted(() => {
      ScrollComponent.reinitialization();
      MenuComponent.reinitialization();
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    //console.log(MainMenuConfig);
    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    return {
      hasActiveChildren,
      MainMenuConfig,
      asideMenuIcons,
      version,
      translate,
      ModuleAcess,
    };
  },
});
